/*
 * --------------------------------------------------------------------------- *
 * File: Main.js                                                               *
 * Project: web                                                                *
 * Created Date: 29 Oct 2022                                                   *
 * Author: Vikas K Solegaonkar (vikas.solegaonkar@gmail.com)                   *
 * Copyright (c) 2022 Vikas K Solegaonkar                                      *
 * https://solegaonkar.com                                                     *
 *                                                                             *
 * Last Modified: Tue Nov 01 2022                                              *
 * Modified By: Vikas K Solegaonkar                                            *
 *                                                                             *
 * HISTORY:                                                                    *
 * --------------------------------------------------------------------------- *
 * Date         By     Comments                                                *
 * --------------------------------------------------------------------------- *
 */

import React, { useContext } from "react";
import { AppContext } from "./context";
import LoginWidget from "./Login";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Constants from "../main/constants";

function Main() {
  const { authenticated } = useContext(AppContext);
  const { showNow } = useContext(AppContext);

  if (authenticated) {
    return (
      <div className="d-flex" id="wrapper">
        <Sidebar />
        <div id="page-content-wrapper">
          <Navbar />
          <div className="container">{Constants.showNowComponent(showNow)}</div>
        </div>
      </div>
    );
  } else {
    return <LoginWidget />;
  }
}

export default Main;
